module.exports = __webpack_public_path__ + "img/ch-Top.f57c2df6.f57c2df6.png";